import { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Button } from 'src/components/system/Button';
import {
  Page,
  Card,
  Title,
  Input,
  Row,
  ErrorText,
  Brand,
  BrandName,
  InputWrapper,
  PasswordToggle,
} from './styles';
import { login } from 'src/services/auth';
import { useAuthProfile } from 'src/hooks/useAuthProfile';
import { buildProfile, cacheProfile } from 'src/services/profile';
import VerticalLogo from 'src/assets/svgs/VerticalLogo';

export function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [remember, setRemember] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { refresh, setProfileValue } = useAuthProfile();
  const [showPassword, setShowPassword] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const { token, ...profilePayload } = await login({ email, password });
      localStorage.setItem('token', token);
      const profileData = buildProfile(profilePayload);
      cacheProfile(profileData);
      setProfileValue(profileData);
      if (remember) localStorage.setItem('rememberEmail', email);
      else localStorage.removeItem('rememberEmail');
      await refresh();
      navigate('/home');
    } catch (err: any) {
      setError('Falha no login. Verifique suas credenciais.');
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    const saved = localStorage.getItem('rememberEmail');
    if (saved) {
      setEmail(saved);
      setRemember(true);
    }
  }, []);

  return (
    <Page>
      <Card>
        <Brand>
          <VerticalLogo width={165} />
          <BrandName>Simulatoro</BrandName>
        </Brand>
        <Title>Entrar</Title>
        <form onSubmit={onSubmit}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            <Input placeholder="Email" type="email" value={email} onChange={e => setEmail(e.target.value)} required />
            <InputWrapper>
              <Input
                placeholder="Senha"
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
              />
              <PasswordToggle type="button" onClick={() => setShowPassword(prev => !prev)}>
                {showPassword ? 'Ocultar senha' : 'Mostrar senha'}
              </PasswordToggle>
            </InputWrapper>
            <label style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <input type="checkbox" checked={remember} onChange={e => setRemember(e.target.checked)} />
              Lembrar meu email
            </label>
            {error && <ErrorText>{error}</ErrorText>}
            <Button
              width="100%"
              backgroundColor="#222B82"
              borderColor="#222B82"
              buttonColor="#fff"
              type="submit"
              disabled={loading}
              label={<span>{loading ? 'Entrando...' : 'Entrar'}</span>}
            />
          </div>
        </form>
        <Row>
          <Link to="/auth/register">Criar conta</Link>
          <Link to="/auth/forgot-password">Esqueci minha senha</Link>
        </Row>
      </Card>
    </Page>
  );
}
